export interface Film {
  id: string;
  title: string;
  category: "伦理片" | "韩剧" | "短剧" | "电影";
  year: number;
  region: string;
  score: number;
  episodes: string;
  tags: string[];
  summary: string;
  badge?: string;
}

export const filmCategories = [
  { key: "all", label: "全部片库", desc: "平台收录的示范片单" },
  { key: "伦理片", label: "伦理片", desc: "聚焦人性、家庭与关系" },
  { key: "韩剧", label: "韩剧", desc: "都市情感与生活流剧集" },
  { key: "短剧", label: "短剧", desc: "单集短、节奏快的轻量剧" },
  { key: "高分电影", label: "高分电影", desc: "口碑评分 8.5 以上" },
] as const;

export const films: Film[] = [
  {
    id: "f01",
    title: "沉默的晚餐",
    category: "伦理片",
    year: 2024,
    region: "中国",
    score: 8.4,
    episodes: "电影",
    tags: ["家庭", "代际", "写实"],
    summary: "一顿没有一句对话的年夜饭，把三代人积攒十年的心结摆上了同一张桌。影片用极少的台词和大量生活细节，让沉默本身成为最刺耳的台词。",
    badge: "本周新片",
  },
  {
    id: "f02",
    title: "母亲的账本",
    category: "伦理片",
    year: 2024,
    region: "中国",
    score: 8.7,
    episodes: "电影",
    tags: ["亲情", "现实", "催泪"],
    summary: "母亲去世后，女儿在一本旧账簿里读到了二十年从未被说出口的打算。每一笔开销背后，都藏着一个她当年并不理解的决定。",
  },
  {
    id: "f03",
    title: "河对岸的女人",
    category: "伦理片",
    year: 2024,
    region: "中国",
    score: 8.3,
    episodes: "电影",
    tags: ["女性", "小镇", "悬疑气质"],
    summary: "小镇渡口旁住了个从不与人来往的女人。一场洪水冲开了她沉默多年的往事，也让邻里重新打量自己曾经的判断。",
  },
  {
    id: "f04",
    title: "无声证词",
    category: "伦理片",
    year: 2023,
    region: "中国",
    score: 8.6,
    episodes: "电影",
    tags: ["法庭", "道德困境", "群像"],
    summary: "一名手语翻译被卷入一桩听障者的纠纷。她要替当事人说出真相，却也必须在两种正义之间做出选择。",
  },
  {
    id: "f05",
    title: "父亲的旧相册",
    category: "伦理片",
    year: 2024,
    region: "中国",
    score: 8.0,
    episodes: "电影",
    tags: ["记忆", "温情", "慢节奏"],
    summary: "儿子在整理遗物时发现相册里总少一个人。顺着照片背面的地名一路找去，他拼出了一个自己从未认识的父亲。",
  },
  {
    id: "f06",
    title: "长夜将尽",
    category: "伦理片",
    year: 2023,
    region: "中国",
    score: 8.1,
    episodes: "电影",
    tags: ["心理", "压抑", "救赎"],
    summary: "一位夜班护工在漫漫长夜里照顾陌生老人，也在一次次对话中，慢慢治好了自己不愿提起的那段过往。",
  },
  {
    id: "f07",
    title: "第五个季节",
    category: "伦理片",
    year: 2022,
    region: "中国",
    score: 7.9,
    episodes: "电影",
    tags: ["文艺", "乡土", "离别"],
    summary: "村庄里的人把每年最安静的那段日子叫作第五个季节。故事就发生在这段时间里，关于留下与离开，谁都没有标准答案。",
  },
  {
    id: "f08",
    title: "冬日的信",
    category: "韩剧",
    year: 2024,
    region: "韩国",
    score: 9.1,
    episodes: "全 16 集",
    tags: ["治愈", "书信", "慢热"],
    summary: "一座北方小城的旧邮局里，被退回的信件被一位代笔人重新读起。每封信都牵出一段被搁置的关系，也牵出他自己的遗憾。",
    badge: "编辑推荐",
  },
  {
    id: "f09",
    title: "海边的公寓",
    category: "韩剧",
    year: 2024,
    region: "韩国",
    score: 8.8,
    episodes: "全 12 集",
    tags: ["群像", "生活流", "温情"],
    summary: "一栋临海老公寓住着七八户人家。看似各自过日子，楼道里的一次停水，让所有人被迫真正认识了彼此。",
  },
  {
    id: "f10",
    title: "我们的春天",
    category: "韩剧",
    year: 2024,
    region: "韩国",
    score: 8.9,
    episodes: "全 16 集",
    tags: ["青春", "成长", "初恋"],
    summary: "四个高中同学约定每年春天见一次。十多年过去，有人先到，有人失约，爱情和友情都在时间里被重新称重。",
  },
  {
    id: "f11",
    title: "首尔凌晨三点",
    category: "韩剧",
    year: 2023,
    region: "韩国",
    score: 8.6,
    episodes: "全 10 集",
    tags: ["都市", "夜班", "现实"],
    summary: "出租车司机、便利店店员和急诊护士，在同一座城市的深夜各自奔忙。三线并行，讲的是都市人彼此照亮的瞬间。",
  },
  {
    id: "f12",
    title: "那年夏天未寄出的信",
    category: "韩剧",
    year: 2022,
    region: "韩国",
    score: 8.7,
    episodes: "全 14 集",
    tags: ["怀旧", "暗恋", "细腻"],
    summary: "女主在搬家时找到一封写于学生时代的信。她带着信回到海边小镇，去完成一件迟到了十五年的告白。",
  },
  {
    id: "f13",
    title: "律师的餐桌",
    category: "韩剧",
    year: 2023,
    region: "韩国",
    score: 8.4,
    episodes: "全 12 集",
    tags: ["职场", "单元剧", "人情"],
    summary: "一位擅长调解的律师把事务所开在自家餐厅里。每一集都用一顿饭，解决一桩看似无解的家事纠纷。",
  },
  {
    id: "f14",
    title: "逆流而上",
    category: "韩剧",
    year: 2024,
    region: "韩国",
    score: 8.2,
    episodes: "全 16 集",
    tags: ["励志", "创业", "友情"],
    summary: "三个被公司裁掉的年轻人决定合伙做点事。理想和现实反复拉扯，他们学会的第一课，是先承认失败。",
  },
  {
    id: "f15",
    title: "三十秒的心动",
    category: "短剧",
    year: 2024,
    region: "中国",
    score: 8.0,
    episodes: "全 30 集 · 短剧",
    tags: ["都市", "快节奏", "甜"],
    summary: "一次电梯故障让两个人被困三十秒。从这句“不好意思”开始，一场跨越大半个城市的老套又可爱的追逐就此展开。",
    badge: "追剧榜上升",
  },
  {
    id: "f16",
    title: "妹妹的秘密身份",
    category: "短剧",
    year: 2024,
    region: "中国",
    score: 7.6,
    episodes: "全 40 集 · 短剧",
    tags: ["反转", "爽感", "悬念"],
    summary: "家里最不起眼的小姑娘，其实是那个所有人都在寻找的关键人物。每三集一次反转，把家族秘密一层层剥开。",
  },
  {
    id: "f17",
    title: "深夜食堂的秘密",
    category: "短剧",
    year: 2023,
    region: "中国",
    score: 8.2,
    episodes: "全 24 集 · 短剧",
    tags: ["单元剧", "暖心", "美食"],
    summary: "巷子口一间只在深夜开的小店，老板从不问客人的来历。一道家常菜配一个短故事，适合睡前慢慢看。",
  },
  {
    id: "f18",
    title: "一纸婚约",
    category: "短剧",
    year: 2023,
    region: "中国",
    score: 7.9,
    episodes: "全 36 集 · 短剧",
    tags: ["先婚后爱", "轻喜", "治愈"],
    summary: "两份被迫签下的合同，意外把两个完全不同的人绑在了一间屋檐下。从互相看不顺眼到舍不得关灯的那盏夜灯。",
  },
  {
    id: "f19",
    title: "她在五分钟后离开",
    category: "短剧",
    year: 2024,
    region: "中国",
    score: 8.1,
    episodes: "全 28 集 · 短剧",
    tags: ["悬疑", "时间线", "烧脑"],
    summary: "女主每次都会在同一个节点失去记忆。她只有五分钟找出真相，否则一切都会重来，而这次她决定不再重来。",
  },
  {
    id: "f20",
    title: "老宅里的钟声",
    category: "短剧",
    year: 2024,
    region: "中国",
    score: 7.7,
    episodes: "全 32 集 · 短剧",
    tags: ["民初", "家族", "恩怨"],
    summary: "一座老宅每到整点就会响起的钟，牵出两代人的恩怨。归乡的年轻人要在钟声停下之前，找出藏在地基下的事。",
  },
  {
    id: "f21",
    title: "群山回响",
    category: "电影",
    year: 2024,
    region: "中国",
    score: 8.9,
    episodes: "电影",
    tags: ["纪实感", "自然", "人文"],
    summary: "一位年轻的地质队员进山勘测，与守着山口几十年的老护林员同行。两个时代的人，在一座山里达成和解。",
    badge: "口碑之作",
  },
  {
    id: "f22",
    title: "白塔之下",
    category: "电影",
    year: 2023,
    region: "中国",
    score: 8.8,
    episodes: "电影",
    tags: ["悬疑", "人性", "冷峻"],
    summary: "一起多年未结的旧案，随着白塔重建再次被翻出。当年的目击者一个个改口，真相却因此越来越近。",
  },
  {
    id: "f23",
    title: "城南旧事新编",
    category: "电影",
    year: 2024,
    region: "中国",
    score: 8.7,
    episodes: "电影",
    tags: ["怀旧", "群像", "城市"],
    summary: "一条即将拆迁的老街，九个住户的最后一个夏天。影片把几十年的城市记忆，装进了一个季节的短暂时光里。",
  },
  {
    id: "f24",
    title: "落日俱乐部",
    category: "电影",
    year: 2024,
    region: "中国",
    score: 8.6,
    episodes: "电影",
    tags: ["公路", "友情", "温柔"],
    summary: "四位退休老人开着一辆旧面包车去看日落。一路上他们吵吵嚷嚷，也把各自没说出口的告别说了出来。",
  },
  {
    id: "f25",
    title: "玻璃海岸",
    category: "电影",
    year: 2023,
    region: "中国",
    score: 8.5,
    episodes: "电影",
    tags: ["爱情", "悬疑", "海"],
    summary: "一名海洋研究员在海岸小镇遇见了一位总在黄昏出现的陌生人。两人各怀目的，却都在这片海边卸下了防备。",
  },
  {
    id: "f26",
    title: "虚构的证人",
    category: "电影",
    year: 2023,
    region: "中国",
    score: 8.4,
    episodes: "电影",
    tags: ["犯罪", "反转", "智斗"],
    summary: "一名调查记者发现关键证人可能根本不存在。为了揭穿谎言，她必须自己先成为故事里的那个人。",
  },
  {
    id: "f27",
    title: "十二号列车",
    category: "电影",
    year: 2024,
    region: "中国",
    score: 8.3,
    episodes: "电影",
    tags: ["密闭空间", "群像", "悬念"],
    summary: "一列停不下来的夜行列车，十二个各怀心事的乘客。当广播喊出无人预订的站名，故事才真正开始。",
  },
  {
    id: "f28",
    title: "沉默的猎人",
    category: "电影",
    year: 2024,
    region: "中国",
    score: 8.2,
    episodes: "电影",
    tags: ["荒野", "复仇", "硬派"],
    summary: "一名独居山林的猎人被迫下山。他要找的不是仇人，而是一段被偷走的约定，过程却远比复仇更难。",
  },
  {
    id: "f29",
    title: "一路向北的公路",
    category: "电影",
    year: 2024,
    region: "中国",
    score: 8.1,
    episodes: "电影",
    tags: ["公路", "父子", "释怀"],
    summary: "一对关系僵硬的父子决定开车去北方看一次极光。两千公里的路上，他们终于把彼此看进了眼里。",
  },
  {
    id: "f30",
    title: "无名之作",
    category: "电影",
    year: 2023,
    region: "中国",
    score: 8.4,
    episodes: "电影",
    tags: ["文艺", "艺术", "自我"],
    summary: "一位过气的画家在晚年重新拿起画笔。他不再追求被看见，而是画给自己看，作品反而有了不一样的力量。",
  },
];

export const hotRanking = [
  { rank: 1, filmId: "f08", trend: "up", heat: 98 },
  { rank: 2, filmId: "f21", trend: "up", heat: 95 },
  { rank: 3, filmId: "f10", trend: "same", heat: 93 },
  { rank: 4, filmId: "f22", trend: "up", heat: 90 },
  { rank: 5, filmId: "f09", trend: "down", heat: 88 },
  { rank: 6, filmId: "f23", trend: "up", heat: 86 },
  { rank: 7, filmId: "f02", trend: "same", heat: 84 },
  { rank: 8, filmId: "f11", trend: "up", heat: 82 },
  { rank: 9, filmId: "f15", trend: "up", heat: 80 },
  { rank: 10, filmId: "f24", trend: "down", heat: 78 },
];